<div class="page-header-container">
    <div class="page-title">
        {{'faqManager.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <button class="btn outline-btn me-3" (click)="saveFrequentlyAskedQuestionsOrder()" [disabled]="isOrderUnchanged">
        <i class="app-icon icon icon-save icon-xl me-2"></i>
        <span>{{'faqManager.saveBtn' | translate}}</span>
    </button>
    <button class="btn primary-btn ms-1" (click)="createFAQ()">
        <i class="app-icon icon icon-add icon-xl me-2"></i>
        <span>{{'faqManager.addBtn' | translate}}</span>
    </button>
</div>

<div class="header-buttons-box">
    <div class="custom-text-input-container search-container flex-grow-1">
        <i class="app-icon icon icon-search icon-xl"></i>
        <kendo-textbox
            type="text"
            [clearButton]='true'
            [placeholder]="'faq.searchPlaceholder' | translate"
            (valueChange)="filterQuestionsList($event)">
        </kendo-textbox>
    </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="hasNoData">
    <no-records-placeholder
        [showNoRecordsHeader]="false"
    ></no-records-placeholder>
</div>
   
<faq-list-view *ngIf="(!hasNoData)"
[frequentlyAskedQuestions]="frequentlyAskedQuestions"
[props] ="props"
[lastQuestionOrder]="lastQuestionOrder"
[isFiltered]="isFiltered"
(deleteFrequentlyAskedQuestionEvent)="deleteFrequentlyAskedQuestionHandler($event)"
(editDetailsEvent)="editDetailsHandler($event)"
(orderChangeEvent)="checkOrder()"
>
</faq-list-view>